import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/home/Home'
import Company from '@/pages/company/Company'
import Contact from '@/pages/contact/Contact'
import Solution from '@/pages/solution/Solution'
import Module from '@/pages/module/Module'
import Download from '@/pages/download/Download'
import Case from '@/pages/case/Case'
import Video from '@/pages/video/Video'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/company',
    name: 'Company',
    component: Company
  }, {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }, {
    path: '/solution',
    name: 'Solution',
    component: Solution
  }, {
    path: '/module',
    name: 'Module',
    component: Module
  }, {
    path: '/download',
    name: 'Download',
    component: Download
  }, {
    path: '/case',
    name: 'Case',
    component: Case
  }, {
    path: '/video',
    name: 'Video',
    component: Video
  }],
  // 解决页面停留上次滚动位置
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js